module.exports = __webpack_public_path__ + "static/media/2.ab3bc7d6.jpg";